<template>
  <div id="reports" v-loading="loading">
    <div class="col-md-12">
      <div class="row">
        <div
          class="col-lg-3"
          v-for="(item, index) in generalStatistics"
          :key="index"
        >
          <div
            class="card"
            :style="{ 'background-color': item.color, color: '#fff' }"
          >
            <div class="card-body">
              <div class="d-flex justify-content-between">
                <h3
                  class="font-weight-semibold mb-0"
                  style="align-self: center"
                >
                  {{ item.value }}
                </h3>
                <img
                  :src="item.image"
                  alt=""
                  width="50"
                  height="50"
                  class="position-absolute mr-3"
                  style="right: 0"
                />
              </div>
              <div>
                {{ item.key }}
                <div class="font-size-sm opacity-75" style="display: none">
                  <template v-if="$i18n.locale == 'tr'">
                    Onay bekleyen <b>0</b> katılımcı
                  </template>
                  <template v-else>
                    <b>0</b> attendee awaiting approval
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6">
          <div class="card" style="padding: 20px 10px; padding-top: 10px">
            <div class="card-title">
              <h5 class="card-title">
                {{ this.$t("reports.activationAnalysis") }}
              </h5>
              <router-link
                :to="{ name: 'participants', params: { activationStatus: 1 } }"
                >{{ this.$t("options.seeAll") }}</router-link
              >
            </div>
            <div :ref="'chart' + 1" :id="'chart' + 1" class="chart"></div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="card" style="padding: 20px 10px; padding-top: 10px">
            <div class="card-title">
              <h5 class="card-title">
                {{ this.$t("reports.totalParticipantsPack") }}
              </h5>
              <router-link :to="{ name: 'participants' }">{{
                this.$t("options.seeAll")
              }}</router-link>
            </div>
            <div :ref="'chart' + 3" :id="'chart' + 3" class="chart"></div>
          </div>
        </div>
        <div class="col-lg-12">
          <div class="card" style="padding: 20px 10px; padding-top: 10px">
            <div class="card-title">
              <h5 class="card-title">
                {{ this.$t("reports.attendanceChartByTags") }}
              </h5>
              <router-link :to="{ name: 'tags' }">{{
                this.$t("options.seeAll")
              }}</router-link>
            </div>
            <div
              :ref="'chart' + 2"
              :id="'chart' + 2"
              class="chart"
              style="height: 400px"
            ></div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="card" style="padding: 20px 10px; padding-top: 10px">
            <div class="card-title">
              <h5 class="card-title">
                {{ this.$t("reports.accessControlByLoc") }}
              </h5>
              <router-link :to="{ name: 'venues' }">{{
                this.$t("options.seeAll")
              }}</router-link>
            </div>
            <el-table :data="data4">
              <el-table-column
                :label="$t('event.table.place')"
                prop="key"
              ></el-table-column>
              <el-table-column
                :label="$t('reports.totalEntry')"
                prop="value"
              ></el-table-column>
              <el-table-column
                :label="$t('reports.singleEntry')"
                prop="valueDistinct"
              ></el-table-column>
            </el-table>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="card" style="padding: 20px 10px; padding-top: 10px">
            <div class="card-title">
              <h5 class="card-title">
                {{ this.$t("reports.accessControlByLive") }}
              </h5>
              <router-link :to="{ name: 'live-sessions' }">{{
                $t("options.seeAll")
              }}</router-link>
            </div>
            <el-table :data="data5">
              <el-table-column
                :label="$t('event.tags.session')"
                prop="key"
              ></el-table-column>
              <el-table-column
                :label="$t('reports.totalEntry')"
                prop="value"
              ></el-table-column>
              <el-table-column
                :label="$t('reports.singleEntry')"
                prop="valueDistinct"
              ></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { stringify } from "@amcharts/amcharts4/.internal/core/utils/Utils";
import Participants from "./Participants";

am4core.useTheme(am4themes_animated);

export default {
  name: "Reports",
  metaInfo: {
    title: "Reports & Statistics",
  },
  components: {
    Participants,
  },
  data() {
    return {
      generalStatistics: [],
      data4: [],
      data5: [],
      loading: true,
    };
  },
  mounted() {
    this.getGeneralStatistics();
    this.initChart1();
    this.initChart2();
    this.initChart3();
  },
  methods: {
    getGeneralStatistics() {
      axios.post("report/GeneralStatistics").then((res) => {
        for (var i = 0; i < res.data.data.items.length; i++) {
          res.data.data.items[i].valueDistinct = null;
        }

        this.generalStatistics = res.data.data.items;
        this.loading = false;

        const options = [
          {
            key: "Toplam Katılımcı",
            color: "#8067dc",
            image: "/static/icons/holacon_reports_icons/totalPart.svg",
          },
          {
            key: "Engellenen Katılımcı",
            color: "#6671db",
            image:
              "/static/icons/holacon_reports_icons/blocked.svg",
          },
          {
            key: "Vekil Eklenen Katılımcı",
            color: "#6894dd",
            image:
              "/static/icons/holacon_reports_icons/proxyAdded.svg",
          },
          {
            key: "Toplam Satış Adedi",
            color: "#68b6dd",
            image: "/static/icons/holacon_reports_icons/totalQuantity.svg",
          },
          {
            key: "Toplam Check-in",
            color: "#a267db",
            image: "/static/icons/holacon_reports_icons/totalCheckin.svg",
          },
          {
            key: "Toplam Kart Baskı",
            color: "#c867db",
            image: "/static/icons/holacon_reports_icons/totalCardP.svg",
          },
          {
            key: "Gönderilen Voucher (E-Posta)",
            color: "#dc67cf",
            image:
              "/static/icons/holacon_reports_icons/voucherMail.svg",
          },
          {
            key: "Gönderilen Voucher (SMS)",
            color: "#dc67ab",
            image:
              "/static/icons/holacon_reports_icons/voucherSMS.svg",
          },
          {
            key: "Toplam Kupon Kodu Grubu",
            color: "#dd6789",
            image:
              "/static/icons/holacon_reports_icons/totalCCGroup.svg",
          },
          {
            key: "Toplam Kupon Kodu Adeti",
            color: "#dc6868",
            image:
              "/static/icons/holacon_reports_icons/totalCCode.svg",
          },
          {
            key: "Kullanılan Kupon Kodu",
            color: "#dc8c67",
            image:
              "/static/icons/holacon_reports_icons/usedCCode.svg",
          },
          {
            key: "Kullanılmayan Kupon Kodu",
            color: "#dbaf66",
            image:
              "/static/icons/holacon_reports_icons/unusedCCode.svg",
          },
        ];

        for (var i = 0; i < this.generalStatistics.length; i++) {
          var generalKey = this.generalStatistics[i].displayName;
          for (var j = 0; j < options.length; j++) {
            var optionKey = options[j].key;
            if (optionKey === generalKey) {
              this.generalStatistics[i].color = options[j].color;
              this.generalStatistics[i].image = options[j].image;
            }
          }
        }

      });
    },
    
    initChart1() {
      axios.post("Report/EventActivation").then((res) => {
        this.chart1 = am4core.create("chart" + 1, am4charts.PieChart);
        this.chart1.data = res.data.data.items.map((i) => {
          return {
            key: i.key,
            value: parseInt(i.value),
          };
        });
        let pieSeries = this.chart1.series.push(new am4charts.PieSeries());
        pieSeries.dataFields.value = "value";
        pieSeries.dataFields.category = "key";

        this.chart1.pieSeries = pieSeries;

        this.chart1.data.some((k) =>
          k.key == "Aktivasyon Yapıldı"
            ? (k.key = this.$t("reports.activated"))
            : ""
        );
        this.chart1.data.some((k) =>
          k.key == "Aktivasyon Bekliyor"
            ? (k.key = this.$t("reports.waitingAct"))
            : ""
        );
        this.chart1.data.some((k) =>
          k.key == "Aktivasyon İptal Edildi"
            ? (k.key = this.$t("reports.canceledAct"))
            : ""
        );
      });
    },
    initChart2() {
      axios.post("Report/ParticipantCountByTag").then((res) => {
        this.chart2 = am4core.create("chart" + 2, am4charts.PieChart);

        this.chart2.data = res.data.data.items.map((i) => {
          return {
            key: i.key,
            value: parseInt(i.value),
          };
        });
        let pieSeries = this.chart2.series.push(new am4charts.PieSeries());
        pieSeries.dataFields.value = "value";
        pieSeries.dataFields.category = "key";

        this.chart2.pieSeries = pieSeries;
        this.chart2.data.some((k) =>
          k.key == "Tek Gün Katılım"
            ? (k.key = this.$t("reports.singleDayAttendance"))
            : ""
        );
        this.chart2.data.some((k) =>
          k.key == "VIP Davetli" ? (k.key = this.$t("reports.vipInvited")) : ""
        );
        this.chart2.data.some((k) =>
          k.key == "Özel Davetli Katılımcı"
            ? (k.key = this.$t("reports.special"))
            : ""
        );
        this.chart2.data.some((k) =>
          k.key == "Tek Gün Katılımcı"
            ? (k.key = this.$t("reports.singleDay"))
            : ""
        );
        this.chart2.data.some((k) =>
          k.key == "Öğrenci" ? (k.key = this.$t("reports.student")) : ""
        );
        this.chart2.data.some((k) =>
          k.key == "Mekan Görevli" ? (k.key = this.$t("reports.venueAtt")) : ""
        );
        this.chart2.data.some((k) =>
          k.key == "Yurtdışı Konuşmacı"
            ? (k.key = this.$t("reports.outSpeaker"))
            : ""
        );
        this.chart2.data.some((k) =>
          k.key == "Sponsor Konuşmacı"
            ? (k.key = this.$t("reports.sponsorSpeaker"))
            : ""
        );
        this.chart2.data.some((k) =>
          k.key == "Konuşmacı" ? (k.key = this.$t("reports.speaker")) : ""
        );
        this.chart2.data.some((k) =>
          k.key == "Yabancı Konuşmacı"
            ? (k.key = this.$t("reports.foreignSpeaker"))
            : ""
        );
        this.chart2.data.some((k) =>
          k.key == "Ücretli Katılımcı"
            ? (k.key = this.$t("reports.paidParticipant"))
            : ""
        );
        this.chart2.data.some((k) =>
          k.key == "Ücretsiz Katılımcı"
            ? (k.key = this.$t("reports.freeParticipant"))
            : ""
        );
        this.chart2.data.some((k) =>
          k.key == "Özel Davetli Katılımcı"
            ? (k.key = this.$t("reports.specialParticipant"))
            : ""
        );
        this.chart2.data.some((k) =>
          k.key == "Sponsor Katılımcı"
            ? (k.key = this.$t("reports.sponsorParticipant"))
            : ""
        );
        this.chart2.data.some((k) =>
          k.key == "Etkinlik Ajansı Görevli"
            ? (k.key = this.$t("reports.eventAgency"))
            : ""
        );
        this.chart2.data.some((k) =>
          k.key == "Kayıt Sistemi Görevli"
            ? (k.key = this.$t("reports.regSystem"))
            : ""
        );
        this.chart2.data.some((k) =>
          k.key == "Mekan Görevl" ? (k.key = this.$t("reports.venueAtt")) : ""
        );
        this.chart2.data.some((k) =>
          k.key == "Stand Görevli" ? (k.key = this.$t("reports.standAtt")) : ""
        );
        this.chart2.data.some((k) =>
          k.key == "Ana Sponsor Katılımcı"
            ? (k.key = this.$t("reports.mainSponsor"))
            : ""
        );
      });
    },
    initChart3() {
      axios.post("Report/SalesStatisticsByPacket").then((res) => {
        this.chart3 = am4core.create("chart" + 3, am4charts.PieChart);

        this.chart3.data = res.data.data.items.map((i) => {
          return {
            key: i.key,
            value: parseInt(i.value),
          };
        });
        let pieSeries = this.chart3.series.push(new am4charts.PieSeries());
        pieSeries.dataFields.value = "value";
        pieSeries.dataFields.category = "key";

        this.chart3.pieSeries = pieSeries;

        this.chart3.data.some((k) =>
          k.key == "Test Sponsorlu Alt Etkinlikli Paket"
            ? (k.key = this.$t("reports.testSponsorSubEvent"))
            : ""
        );
        this.chart3.data.some((k) =>
          k.key == "Standart Katılım"
            ? (k.key = this.$t("reports.standard"))
            : ""
        );
        this.chart3.data.some((k) =>
          k.key == "Basın" ? (k.key = this.$t("reports.press")) : ""
        );
        this.chart3.data.some((k) =>
          k.key == "Tek Gün Katılım"
            ? (k.key = this.$t("reports.singleDayAttendance"))
            : ""
        );
      });

      axios.post("Report/AccessLogByVenue").then((res) => {
        this.data4 = res.data.data.items;
      });

      axios.post("Report/AccessLogByLiveStream").then((res) => {
        this.data5 = res.data.data.items;
      });
    },
  },
};
</script>

<style scoped>
.card-title {
  display: flex;
  justify-content: space-between;
}
a {
  color: #111111;
}

a:hover {
  font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/pages/event/Reports.vue